import localforage from 'localforage';
import { IVehicle, IVehicleGdprDataAllowed } from '../components/Vehicles/types';

export interface ITripsOverviewActionsData {
  id: number;
  parking: {
    id: number;
    summary: {
      [key: string]: number;
    };
    info: {
      records: any;
    };
  };
  info: {
    summary: {
      [key: string]: number;
    };
    records: any;
  };
  isPrivate: boolean;
  driver: {
    id: number;
  };
  customer: {
    id: number;
  };
  timestamp: {
    start: Date;
    end: Date;
  };
  vehicle: {
    id: number;
    name: string;
  };
  address: {
    start: string;
    end: string;
  };
  locked?: string;
}

const GDPR_CHANGE_RIDE_PRIVACY = 'changeRidePrivacy';
const GDPR_CHANGE_DRIVER = 'changeDriver';
const GDPR_BASIC = 'basic';

const GdprService = {
  async getRideGdpr(
    canType: string,
    isPrivate: boolean,
    customerId: number,
    driverId: number | null
  ): Promise<boolean> {
    if (!isPrivate) {
      return true;
    }
    const loggedDriverId = localStorage.getItem('driverId');
    if (driverId && String(loggedDriverId) === String(driverId)) {
      return true;
    }
    const profiles = await localforage.getItem<Record<string, any>[]>('gdprSettings');
    if (Array.isArray(profiles) && profiles.length > 0) {
      const profile = profiles.find((i: any) => String(i.customerId) === String(customerId));
      if (profile && profile.authRides && profile.authRides[0] && profile.authRides[0].can) {
        if (!profile.authRides[0].enabled) {
          return false;
        }
        if (canType === GDPR_BASIC) {
          return true;
        }
        if (canType === GDPR_CHANGE_RIDE_PRIVACY || canType === GDPR_CHANGE_DRIVER) {
          return profile.authRides[0].can[canType];
        }
        return profile.authRides[0].can[canType] && profile.authRides[0].can.showPrivateData;
      }
      return true;
    }
    return true;
  },

  async getRideGdprByTypes(
    canTypes: string[],
    isPrivate: boolean,
    customerId: number,
    driverId: number | null
  ): Promise<string[]> {
    if (!isPrivate) {
      return canTypes;
    }
    const loggedDriverId = localStorage.getItem('driverId');
    if (driverId && String(loggedDriverId) === String(driverId)) {
      return canTypes;
    }
    const profiles = await localforage.getItem<Record<string, any>[]>('gdprSettings');
    if (Array.isArray(profiles) && profiles.length > 0) {
      const profile = profiles.find((i: any) => String(i.customerId) === String(customerId));
      if (profile && profile.authRides && profile.authRides[0] && profile.authRides[0].can) {
        if (!profile.authRides[0].enabled) {
          return [];
        }
        const allowedTypes: string[] = [];
        canTypes.forEach((canType: string) => {
          if (canType === GDPR_BASIC) {
            allowedTypes.push(canType);
          } else if (canType === GDPR_CHANGE_RIDE_PRIVACY || canType === GDPR_CHANGE_DRIVER) {
            if (profile.authRides[0].can[canType]) {
              allowedTypes.push(canType);
            }
          } else if (
            profile.authRides[0].can[canType] &&
            profile.authRides[0].can.showPrivateData
          ) {
            allowedTypes.push(canType);
          }
        });
        return allowedTypes;
      }
      return canTypes;
    }
    return canTypes;
  },

  getPermission(vehicle: IVehicle, vehicleId: number, gdprDataAllowed: IVehicleGdprDataAllowed) {
    if (vehicle && vehicleId && Number.isInteger(vehicleId)) {
      if (vehicle.drivingMode === 'private') {
        if (vehicleId && Number.isInteger(vehicleId) && gdprDataAllowed) {
          return gdprDataAllowed[vehicleId];
        }
        return false;
      }
      if (vehicle.drivingMode === 'business') {
        return true;
      }

      // If vehicle has nullable vehicle status (aka is newly created and whitout any ride) show online panel
      if (vehicle[vehicleId] && vehicle[vehicleId].status === null) {
        return true;
      }

      return gdprDataAllowed[vehicleId];
    }
    return true;
  },
};

export default GdprService;
